import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import {getElement, getElements} from './../utils/functional'

export default function init ({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.querySelector(`.${moduleClassName}_Carousel`)
  const swiperNext = el.getElementsByClassName(`${moduleClassName}_Next`)[0]
  const swiperPrevious = el.getElementsByClassName(`${moduleClassName}_Previous`)[0]

  makeCarousel()

  window.addEventListener('resize', makeCarousel)
 
  function makeCarousel () {
    initialiseCarousel(
      swiperContainer,
      {
        loop: false,
        preloadImages: false,
        lazy: true,
        spaceBetween: 0,
        slideClass: `${moduleClassName}_Slide`,
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrevious,
          disabledClass: 'section__reviews__swiper__navigation__disabled',
        }
      }
    )
  }
}